"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_PDF = exports.LOAD_ONE = void 0;
var LOAD_ONE = exports.LOAD_ONE = 'app/digitalID/LOAD_ONE';
var LOAD_PDF = exports.LOAD_PDF = 'app/digitalID/LOAD_PDF';